if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        /* =========================================
          HIGHLINE RING RESIZING SERVICE
        ========================================= */

        const sizingBox = document.getElementById(
          `HLRingSizing-${this.dataset.sectionId}`
        );

        let resizingFee = 0;
        let resizeServiceVariantId = null;
        let requestedRingSize = null;
        let originalRingSize = null;

        if (sizingBox) {
          const ringSizeSelect = sizingBox.querySelector('.hl-ring-size-select');

          /* Require ring size selection */
          if (!ringSizeSelect || !ringSizeSelect.value) {
            this.handleErrorMessage('Please select a ring size.');

            this.submitButton.removeAttribute('aria-disabled');
            this.submitButton.classList.remove('loading');
            this.querySelector('.loading__spinner').classList.add('hidden');

            return;
          }

          requestedRingSize = ringSizeSelect.value;
          originalRingSize = sizingBox.dataset.originalSize;
          resizingFee = parseInt(sizingBox.dataset.resizingFee || '0', 10);

          if (resizingFee > 0) {
            const variantMapElement = document.getElementById(
              `HLResizeVariants-${this.dataset.sectionId}`
            );

            if (!variantMapElement) {
              this.handleErrorMessage('Resizing service is temporarily unavailable.');

              this.submitButton.removeAttribute('aria-disabled');
              this.submitButton.classList.remove('loading');
              this.querySelector('.loading__spinner').classList.add('hidden');

              return;
            }

            try {
              const resizeVariants = JSON.parse(variantMapElement.textContent);
              resizeServiceVariantId = resizeVariants[String(resizingFee)];
            } catch (error) {
              console.error('Resize variant map error:', error);
            }

            if (!resizeServiceVariantId) {
              this.handleErrorMessage(
                `Cannot find the $${resizingFee} resizing service.`
              );

              this.submitButton.removeAttribute('aria-disabled');
              this.submitButton.classList.remove('loading');
              this.querySelector('.loading__spinner').classList.add('hidden');

              return;
            }
          }
        }

        /* ========================================= */

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            /* =========================================
              ADD RESIZING SERVICE
            ========================================= */

            if (resizeServiceVariantId && resizingFee > 0) {

              const serviceFormData = new FormData();

              serviceFormData.append('id', resizeServiceVariantId);

              /* Match service quantity to ring quantity */
              serviceFormData.append(
                'quantity',
                formData.get('quantity') || 1
              );

              /* Information for staff/order */
              serviceFormData.append(
                'properties[Ring]',
                sizingBox.dataset.productTitle || 'Ring'
              );

              serviceFormData.append(
                'properties[Original Size]',
                originalRingSize
              );

              serviceFormData.append(
                'properties[Requested Size]',
                requestedRingSize
              );

              if (this.cart) {
                serviceFormData.append(
                  'sections',
                  this.cart.getSectionsToRender().map((section) => section.id)
                );

                serviceFormData.append(
                  'sections_url',
                  window.location.pathname
                );
              }

              const serviceConfig = fetchConfig('javascript');

              serviceConfig.headers['X-Requested-With'] = 'XMLHttpRequest';
              delete serviceConfig.headers['Content-Type'];

              serviceConfig.body = serviceFormData;

              return fetch(`${routes.cart_add_url}`, serviceConfig)
                .then((serviceResponse) => serviceResponse.json())
                .then((serviceResponse) => {

                  if (serviceResponse.status) {
                    console.error(
                      'Ring resizing service error:',
                      serviceResponse
                    );

                    this.handleErrorMessage(
                      'The ring was added, but there was a problem adding the resizing service.'
                    );

                    return;
                  }

                  this.error = false;

                  publish(PUB_SUB_EVENTS.cartUpdate, {
                    source: 'product-form',
                    productVariantId: formData.get('id'),
                    cartData: serviceResponse,
                  });

                  if (this.cart) {
                    CartPerformance.measure(
                      "add:paint-updated-sections",
                      () => {
                        this.cart.renderContents(serviceResponse);
                      }
                    );
                  }

                  return;
                });
            }

            /* ========================================= */

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
